import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To120(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectRatio1To120"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 3.5h-2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M4.5 2A2.5 2.5 0 0 0 2 4.5v11A2.5 2.5 0 0 0 4.5 18h2A2.5 2.5 0 0 0 9 15.5v-11A2.5 2.5 0 0 0 6.5 2zm6.988 1.75a.75.75 0 0 1 .75-.75h6.006a.75.75 0 0 1 0 1.5h-6.006a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5h6.006a.75.75 0 0 0 0-1.5zm-.75-2.25a.75.75 0 0 1 .75-.75h4.015a.75.75 0 0 1 0 1.5h-4.015a.75.75 0 0 1-.75-.75m.75 5.25a.75.75 0 0 0 0 1.5h4.015a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To120);
